import { DecodeJWT } from "@Helpers/JWT.helper";
import Instance from "@Service/Instance";
import { CrmUsersViewModel } from "@Service/Models";
import secureLocalStorage from "react-secure-storage";

export const isValidToken = (accessToken: string) => {
  if (!accessToken) {
    return false;
  }

  const decoded = DecodeJWT(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

export const tokenExpired = (exp: number) => {
  const currentTime = Math.floor(Date.now() / 1000);
  if (exp && exp < currentTime) {
    localStorage.removeItem("accessToken");

    return false;
  }
};

export const isJWTValid = (token: string) => {
  const parts = token.split(".");
  if (parts.length !== 3) return false;

  try {
    const payload = atob(parts[1].replace(/-/g, "+").replace(/_/g, "/"));
    const parsedPayload = JSON.parse(payload);

    const currentTime = Math.floor(Date.now() / 1000);
    if (parsedPayload.exp && parsedPayload.exp < currentTime) {
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (_) {
    return false;
  }

  return true; // Token geçerli
};

export const setSession = (user: CrmUsersViewModel | null) => {
  if (user) {
    secureLocalStorage.setItem("user", JSON.stringify(user));

    Instance.defaults.headers.common.AccessToken = user.accessToken;
  } else {
    secureLocalStorage.removeItem("user");

    delete Instance.defaults.headers.common.AccessToken;
  }
};
